<template>
    <b-container fluid class="animated fadeIn">
        <h1>EXIBIR CONFIGURAÇÃO TIPO DE CRÉDITO / ASSUNTO</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
                        <multiselect
                            name="tipoCredito"
                            v-model="tipoCreditoAssunto.tipoCredito"
                            :disabled="true"
                            :show-labels="false"
                            :options="dados.tiposCredito"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="id"
                            label="nome"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Assunto:" label-for="assunto" class="text-label">
                        <b-form-input
                                name="assunto"
                                v-model="tipoCreditoAssunto.assunto"
                                type="text"
                                maxlength="150"
                                :disabled="true"/>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button variant="primary" class="ml-2" @click="voltar" :disabled="inSave">
                        <i class="fa fa-reply"></i> Voltar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'

export default {
    name: 'ManterTipoCreditoAssuntoEditar',
    data() {
        return {
            tipoCreditoAssunto: {
                codTipoCreditoAssunto: null,
                assunto: null,
                tipoCredito: null,
            },
            dados: {
                tiposCredito: [],
            },
        }
    },
    methods: {
        voltar() {
            this.$store.commit("setTipoCreditoAssunto", null);
            this.$router.push({ path: '/tipo-credito-assunto' })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Listar tipos de crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/parametros/listarTipoCredito`)
            .then(response => {
              this.dados.tiposCredito = response.data
            })
        },

    },
    mounted() {
        this.$store.commit("setMessages", {});

        const tipoCreditoAssuntoEditada = this.$store.getters.getTipoCreditoAssunto;
        if(tipoCreditoAssuntoEditada) {
            this.tipoCreditoAssunto = tipoCreditoAssuntoEditada;
        }

        this.listarTipoCredito();
    }
    
}
</script>

<style scoped>

</style>